import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_@babel+core@7.14.3_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import { Badge, Card, Cell, DeprecatedIcon, Image, Text } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { CATALOG_SHRINK_THRESHOLD, ROOT_CATALOG_ICON_NAME, ROOT_CATALOG_ID, WEB_CATALOG_ROOT_ALL_CODE } from 'constants/catalog';
import { navigateToPage } from 'libs/utils/window';
import CatalogsPanel from '../CatalogsPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const CategoriesPanel = _ref => {
  var _rootCategory$catalog;

  let {
    rootCategory,
    triggerCatalogModal
  } = _ref;
  const translate = useTranslate();
  const {
    0: selectedCategoryId,
    1: setSelectedCategoryId
  } = useState(((_rootCategory$catalog = rootCategory.catalogs[0]) === null || _rootCategory$catalog === void 0 ? void 0 : _rootCategory$catalog.id) || ROOT_CATALOG_ID);

  const parentCatalog = _objectSpread(_objectSpread({}, rootCategory), {}, {
    code: WEB_CATALOG_ROOT_ALL_CODE,
    title: translate('header.main_navigation.catalogs.see_all')
  });

  const categoryList = [parentCatalog, ...rootCategory.catalogs];
  const categoriesCellStyling = categoryList.length >= CATALOG_SHRINK_THRESHOLD ? Cell.Styling.Narrow : undefined;

  const handleTitleClick = _ref2 => {
    let {
      id,
      url,
      code,
      title,
      catalogs,
      landing
    } = _ref2;
    return event => {
      event.preventDefault();
      event.stopPropagation();

      if (catalogs.length && code !== WEB_CATALOG_ROOT_ALL_CODE && !landing) {
        event.nativeEvent.stopImmediatePropagation();
        setSelectedCategoryId(id);
      } else if (landing) {
        triggerCatalogModal({
          catalogName: title,
          itemsRemaining: landing.itemsRemaining,
          imageUrl: landing.imageUrl
        });
      } else {
        navigateToPage(url);
      }
    };
  };

  const renderCategoriesItem = item => {
    var _item$photo;

    return /*#__PURE__*/_jsx(Cell, {
      type: Cell.Type.Navigating,
      styling: categoriesCellStyling,
      prefix: item.code === WEB_CATALOG_ROOT_ALL_CODE ? /*#__PURE__*/_jsx(DeprecatedIcon, {
        name: ROOT_CATALOG_ICON_NAME,
        color: DeprecatedIcon.Color.Primary
      }) : /*#__PURE__*/_jsx(Image, {
        src: (_item$photo = item.photo) === null || _item$photo === void 0 ? void 0 : _item$photo.url,
        scaling: Image.Scaling.Cover,
        size: Image.Size.Regular
      }),
      suffix: item.landing && /*#__PURE__*/_jsx(Badge, {
        theme: "primary",
        content: translate('common.new_badge')
      }),
      body: /*#__PURE__*/_jsx(Text, {
        truncate: true,
        bold: item.id === selectedCategoryId,
        theme: item.id === selectedCategoryId ? 'amplified' : 'inherit',
        children: item.title
      }),
      url: item.url,
      urlProps: {
        title: item.title
      },
      onClick: handleTitleClick(item),
      testId: "category-item-".concat(item.id),
      aria: {
        'aria-label': item.title
      }
    }, item.id);
  };

  const renderCatalogsItem = item => /*#__PURE__*/_jsx(CatalogsPanel, {
    selectedCategory: item,
    selectedCategoryId: selectedCategoryId,
    triggerCatalogModal: triggerCatalogModal
  }, item.id);

  const renderCategoriesBody = () => /*#__PURE__*/_jsx("div", {
    className: "catalog-dropdown__content",
    children: /*#__PURE__*/_jsxs("div", {
      className: "u-flexbox",
      children: [/*#__PURE__*/_jsx("div", {
        className: "catalog-dropdown__categories",
        children: categoryList.map(renderCategoriesItem)
      }), /*#__PURE__*/_jsx("div", {
        className: "catalog-dropdown__catalogs",
        children: categoryList.map(renderCatalogsItem)
      })]
    })
  });

  return /*#__PURE__*/_jsx("div", {
    className: "catalog-dropdown",
    children: /*#__PURE__*/_jsx(Card, {
      styling: Card.Styling.Elevated,
      children: /*#__PURE__*/_jsx("div", {
        className: "u-overflow-auto",
        children: /*#__PURE__*/_jsx(Cell, {
          styling: Cell.Styling.Narrow,
          body: renderCategoriesBody()
        })
      })
    })
  });
};

export default CategoriesPanel;